const Button = (props) => {
    return (
        <button type={props.type ? props.type : 'button'} className={`mainBtn ${props.className ? props.className : ''}`} onClick={props.onClick} style={{ backgroundColor: props.color }}>
            {props.text}
        </button>
    )
}

export default Button;